export default {
  namespaced: true,
  messages: {
    delete: {
      title: "Are you sure to remove it?",
      body: "If you remove it, you lost all elements related with it",
      deleted_correctly: "Deleted successfully",
      title_n: "Are you sure to remove {n} elements?",
      all: "Are you sure to delete everything?",
    },
    reset: {
      title: "Are you sure that you wanna reset the password?",
      counter_title: "Reset Counter",
      counter: "Are you sure that you wanna reset the counter",
    },
    error: {
      server_error: "error when trying to get the information",
      task_not_assigned: "Error assigning task",
      max_files_exceeded: "You have exceeded the maximum number of files allowed",
    },
    success: {
      task_assigned: "Task assigned successfully",
      task_completed: "Task marked as done",
      alarm_reopened: "Alarm reopened successfully",
    },
    validation: {
      required: "The field {field} is required",
      email_placeholder: "type one or more emails",
      missing_fields: {
        title: "Missing required fields",
        text: "Please complete the following fields: {fields}"
      }
    },
    info: {
      begin_download: "starting the process to export video...",
      in_process_download: "the process has been started successfully...",
      finish_download: "Recording downloaded successfully",
      sending: "sending",
      advanced_search: "advanced search",
      clear_filters: "clear filters",
      select: "select",
    },
    export: {
      title: "Export",
      download: "Download",
      Generating_file: "Generating file...",
      download_succesfully: "Download successfully",
      report_of: "Report of {model}",
      report: "Report of",
      full_download: "Full download",
      downloading_file: 'Downloading file...',
    },
    edit_save: {
      successfully_created: "Successfully created",
      updated_successfully: "Updated successfully",
      updated_successfully_withoutCameraUrl: "Updated successfully without updating camera URL",
    },
    copy: {
      copied_successfully: "Copied successfully",
      could_not_copy: "Could not copy",
    },
    import: {
      title: "Import",
      rems: "Import REMS file",
      select_file: "Select or drag and drop the file",
      upload: "Uploading",
      uploading_file: "Uploading file...",
      upload_succesfully: "Upload successfully",
      example_file: "Example File",
    },
    loading: {
      title: "Loading",
      document: "Loading document..."
    },
    redirect: {
      login: "We will redirect you to the login in 5 seconds"
    },
    greetings: {
      change_password: "hi {name},"
    },
    session_expiration: {
      expiration: "The session is about to expire at",
      continue_session: "Continue session"
    },
    session_lifetime: {
      lifetime_exceeded: "You've been inactive; the session will close when the time limit is reached.",
      continue_session: "Continue session"
    },
    errors: {
      general: "An error has ocurred",
      loading_document: "Error loading document",
      showing_document: "Error showing document",
      loading_service_orders: "Error loading service orders"
    },
    processing: "processing",
    activate: {
      title: "Are you sure to activate ",
      body: "If you activate it, you will be able to use it",
      activated_correctly: "Activated successfully",
      activated_correctly_confirm: "Activated successfully",
      armed_correctly: "Armed successfully",
      armed_correctly_confirm: "Activated successfully",
      error: "There was an error executing the action",
      confirm: "Confirm",
      activating: "Activating",
    },
    desactivate: {
      title: "Are you sure to deactivate",
      body: "If you deactivate it, you will not be able to use it",
      desactivated_correctly: "Deactivated successfully",
      confirm: "Confirm",
      desactivated_correctly_confirm: "Deactivated successfully",
      error: "There was an error executing the action",
      deactivating: "Desactivating",
      disarmed_correctly: "Disarmed successfully",
      disarmed_correctly_confirm: "Disarmed successfully",
    },
    actions: {
      apply_state: "Apply state",
      no_action_selected: "No action selected",
      executing: "Executing",
      in: "in",
      executed_successfully: 'Action "{action}" executed successfully',
      error_executing: "Error executing the action",
    },
    table_refreshed: "Table refreshed successfully",
    warning: {
      title: "Warning",
    },
  },
};
